import * as Sentry from '@sentry/nextjs';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { AxiosError } from 'axios';
import { InferGetServerSidePropsType } from 'next';

import { wrapper } from '@store/store';

import Lookbook from '@routes/Lookbook';

import { fetchCMSComponentsData } from '@utils/fetchCMSComponentsData';
import { slugRouteRedirectsHandler } from '@utils/redirects';
import { getLocaleFromContext } from '@utils/getLocaleFromContext';
import { getRequestInstance } from '@utils/request';

import * as endpoints from '@common/endpoints';
import { LookbookPageData } from '@common/types/cms';

const LookbookPage = ({
  pageData,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => (
  <Lookbook pageData={pageData} />
);

type QueryParams = {
  slug: string[];
};

export const getServerSideProps = wrapper.getServerSideProps(
  store => async context => {
    const { params, resolvedUrl } = context;
    const locale = getLocaleFromContext(context);
    const request = getRequestInstance(context);
    const { slug } = params as QueryParams;
    let pageData: LookbookPageData;

    try {
      const { data } = await request.get(
        endpoints.cmsLookbooksPage(slug.join('/')),
      );

      await fetchCMSComponentsData(store.dispatch, data);
      pageData = data;
    } catch (error) {
      if (error instanceof AxiosError && error?.response?.status !== 404) {
        Sentry.captureException(error);
      }

      return slugRouteRedirectsHandler(slug, resolvedUrl, locale);
    }

    return {
      props: {
        ...(await serverSideTranslations(locale)),
        pageData,
      },
    };
  },
);

export default LookbookPage;
